import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/')({
  beforeLoad: ({ preload }) => {
    if (!preload) {
      throw redirect({ to: '/author/article', replace: true });
    }
  },
});
